import React from 'react';
import { Box, Typography, Grid, Paper, useTheme } from '@mui/material';
import { TiktokIcon } from '../../assets/TiktokIcon';
import { InstaIcon } from '../../assets/InstaIcon';
import { SnapIcon } from '../../assets/SnapIcon';
import { FBIcon } from '../../assets/FBIcon';

export const SocialUploadPrompt: React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      style={{
        backgroundPosition: 'center',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 16px',
        zIndex: 2,
      }}
    >
      <Paper
        elevation={3}
        style={{
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
          border: `1px solid ${theme.palette.primary.main}`,
          borderRadius: '12px',
          padding: '14px 14px 0px 14px',
          width: '100%',
          textAlign: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          fontWeight="bold"
          color="#4F49E1"
          // gutterBottom
          fontSize={'clamp(13px, 5vw, 18px)'}
          style={{ whiteSpace: 'nowrap' }}
        >
          What types of videos are best?
        </Typography>
        <Typography variant="h6" color="green" fontSize={'clamp(13px, 5vw, 18px)'} fontWeight={'600'} maxWidth={'294px'}>
          Upload a video you plan to share on Social Media!
        </Typography>

        <Grid container spacing={1} justifyContent="center" style={{ transform: 'scale(0.8)' }}>
          <Grid item>
            <Box color="#3b5998" fontSize={48}>
              <FBIcon />
            </Box>
          </Grid>
          <Grid item>
            <Box color="#000000" fontSize={48}>
              <TiktokIcon />
            </Box>
          </Grid>
          <Grid item>
            <Box
              sx={{
                fontSize: 48,
                background: 'linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              <InstaIcon />
            </Box>
          </Grid>
          <Grid item>
            <Box fontSize={48} color="#fffc00">
              <SnapIcon />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
